import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import es from './locales/es.json'
import en from './locales/en.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: { escapeValue: false },
  })

/**
 * El atributo `lang` del documento sigue al selector ES/EN.
 *
 * Va aqui y no en el boton de la barra lateral por dos razones. Una, que hay dos
 * botones —el del menu desplegado y el del plegado— y la verdad no puede vivir
 * en los dos. Y otra, que el idioma inicial no lo elige ningun boton: lo decide
 * el detector desde `localStorage` o desde el navegador, asi que un `onClick` no
 * llegaria nunca a ese primer valor.
 *
 * Sin esto el documento se queda en `lang="es"` con la interfaz en ingles, y eso
 * no es cosmetico: es lo que usan el lector de pantalla para elegir voz y el
 * navegador para partir palabras y para ofrecer traduccion.
 */
function sincronizarLang(lng: string) {
  // `i18n` tambien se importa en los tests, donde no siempre hay documento.
  if (typeof document === 'undefined') return
  document.documentElement.lang = lng.startsWith('en') ? 'en' : 'es'
}

sincronizarLang(i18n.resolvedLanguage ?? i18n.language ?? 'es')
i18n.on('languageChanged', sincronizarLang)

export default i18n
